export enum AudioEffectEvent {
  'EFFECT_ADD_EFFECT' = 'EFFECT_ADD_EFFECT',
  'EFFECT_UPDATE_EFFECT' = 'EFFECT_UPDATE_EFFECT',
  'EFFECT_DELETE_EFFECT' = 'EFFECT_DELETE_EFFECT',
}
